module.exports = __webpack_public_path__ + "img/cake-6.d26f50ed.svg";